import styled from 'styled-components'
import { widthResize, widthFull, bgApp, navy, muted, primary, heightHeader } from '../Resources/Theme'

const PageWrapper = styled.div`
  margin-left: ${props => props.resize ? widthResize : widthFull};
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  transition: width 0.28s ease, margin 0.28s ease;
  background: ${bgApp};
  min-height: 100vh;

  @media (max-width: 992px) {
    width: 100%;
    margin-left: 0;
  }
`

PageWrapper.BgTop = styled.div`
  padding-top: 0;
  width: 100%;
  min-height: auto;
  display: flex;
  color: ${navy};
  background: transparent;
`

PageWrapper.Title = styled.div`
  margin-bottom: 0;
  align-self: center;
  background: transparent;
  padding: 20px 24px 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  @media (max-width: 992px) {
    font-size: 1.05rem;
    padding: 16px 16px 4px;
  }
`

PageWrapper.Eyebrow = styled.span`
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${primary};
`

PageWrapper.Heading = styled.h1`
  margin: 0;
  font-size: 1.55rem;
  font-weight: 700;
  color: ${navy};
  line-height: 1.25;

  @media (max-width: 992px) {
    font-size: 1.25rem;
  }
`

PageWrapper.Subtitle = styled.p`
  margin: 0;
  font-size: 0.88rem;
  color: ${muted};
  max-width: 560px;
`

PageWrapper.Body = styled.div`
  margin-top: 0;
  position: relative;
  padding: 24px 28px 48px;
  min-height: calc(100vh - ${heightHeader});
  animation: sp-fade-up 0.28s ease both;

  @media (max-width: 992px) {
    padding: 16px 14px 40px;
  }
`

/* Start BreadCrumb */
PageWrapper.BreadCrumb = styled.div`
  font-weight: 500;
  display: flex;
  align-self: center;
  font-size: 0.8rem;
  color: ${muted};
  margin-top: 4px;

  @media (max-width: 992px) {
    display: none;
  }
`

PageWrapper.BreadCrumb.Title = styled.span`
  margin-right: 0.7rem;
  display: flex;
  font-weight: ${props => props.active ? '700' : '500'};
  align-self: center;
  color: ${props => props.active ? navy : muted};
`

PageWrapper.BreadCrumb.Icon = styled.div`
  align-self: center;
  transform: rotate(135deg);
  content: '';
  width: 5px;
  height: 5px;
  border-width: 1px 0 0 1px;
  border-style: solid;
  margin-right: 0.7rem;
  border-color: ${muted};
`
/* End BreadCrumb */

export default PageWrapper
